import { render } from "./HiddenOrdersTab.vue?vue&type=template&id=4f2f6d6a&scoped=true"
import script from "./HiddenOrdersTab.vue?vue&type=script&lang=js"
export * from "./HiddenOrdersTab.vue?vue&type=script&lang=js"

import "./HiddenOrdersTab.vue?vue&type=style&index=0&id=4f2f6d6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f2f6d6a"]])

export default __exports__